import React from 'react'

export class CheckBoxComponent extends React.Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.props.onChange(!this.props.value)
  }

  titleProps() {
    return {
      __html: this.props.title
    }
  }

  render() {
    return (
      <div className={"checkbox " + (this.props.value ? 'active' : '') + (this.props.cl ? (' ' + this.props.cl) : '')}>
        <div className="checkbox__label" onClick={this.toggle}>
        </div>
        <div className="checkbox__title" dangerouslySetInnerHTML={this.titleProps()}>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/checkbox/checkbox.component.jsx